import React, { useState } from "react";
import { PageHeader, Panel, Table, Pager, useAdminQuery, RefreshButton, Unavailable, StatusChip, fmtDate, fmtDuration, INK, MUTE, BORDER } from "../_shared";
import { AlertTriangle } from "lucide-react";

export default function AdminReports() {
  const [page, setPage] = useState(1);
  const [status, setStatus] = useState("");
  const [q, setQ] = useState("");
  const [search, setSearch] = useState("");
  const r = useAdminQuery("/admin/reports/jobs", { page, page_size: 25, status: status || undefined, q: search || undefined });

  return (
    <div data-testid="admin-reports-page">
      <PageHeader title="Life Reports"
        subtitle="Durable background jobs — every reservation, capture, refund."
        right={<RefreshButton loading={r.loading} onClick={r.refresh} />} />

      {!!r.data?.warnings?.length && (
        <Panel testId="admin-reports-warnings">
          <div style={{ display: "flex", gap: 8, alignItems: "center", color: "#B91C1C",
                         fontSize: 13, fontWeight: 500, marginBottom: 10 }}>
            <AlertTriangle size={16} /> {r.data.warnings.length} warning(s) — captured credits without a completed report
          </div>
          <Table cols={[
            { label: "User",    render: (w) => <code style={{ fontSize: 11 }}>{(w.user_id || "").slice(0,14)}</code> },
            { label: "Report",  render: (w) => <code style={{ fontSize: 11 }}>{(w.report_id || "").slice(0,10)}</code> },
            { label: "Ledger",  render: (w) => <code style={{ fontSize: 11 }}>{(w.ledger_id || "").slice(0,10)}</code> },
            { label: "When",    render: (w) => fmtDate(w.ts) },
            { label: "Message", render: (w) => <span style={{ color: MUTE, fontSize: 12 }}>{w.message}</span> },
          ]} rows={r.data.warnings} />
        </Panel>
      )}

      <Panel>
        <form onSubmit={(e) => { e.preventDefault(); setSearch(q); setPage(1); }}
              style={{ display: "flex", gap: 10, marginBottom: 14, flexWrap: "wrap" }}>
          <input value={q} onChange={(e) => setQ(e.target.value)}
                 placeholder="Search job_id, user_id, report_id"
                 data-testid="admin-reports-search"
                 style={inputStyle} />
          <select value={status} onChange={(e) => { setStatus(e.target.value); setPage(1); }}
                   data-testid="admin-reports-status"
                   style={inputStyle}>
            <option value="">All</option>
            <option>QUEUED</option>
            <option>GENERATING</option>
            <option>RENDERING</option>
            <option>VALIDATING</option>
            <option>COMPLETED</option>
            <option>FAILED</option>
            <option>REFUNDED</option>
          </select>
          <button type="submit" style={{ padding: "8px 16px", borderRadius: 999,
            background: INK, color: "white", border: 0, cursor: "pointer", fontSize: 12.5 }}>
            Search
          </button>
        </form>

        {r.loading ? <Loading /> : r.error ? <Unavailable error={r.error} /> : (
          <>
            <Table cols={[
              { label: "Job",      render: (x) => <code style={{ fontSize: 11 }}>{(x.job_id || "").slice(0,10)}</code> },
              { label: "User",     render: (x) => <code style={{ fontSize: 11 }}>{(x.user_id || "").slice(0,14)}</code> },
              { label: "Status",   render: (x) => <StatusChip status={x.status} /> },
              { label: "Stage",    render: (x) => <span style={{ color: MUTE, fontSize: 11 }}>{x.stage}</span> },
              { label: "Created",  render: (x) => fmtDate(x.created_at) },
              { label: "Duration", render: (x) => fmtDuration(x.duration_seconds) },
              { label: "Reserved", render: (x) => `${x.price_credits || 500}` },
              { label: "Payment",  render: (x) => <StatusChip status={x.payment_status || "—"} /> },
              { label: "Error",    render: (x) => <span style={{ color: "#B91C1C", fontSize: 11 }}>{x.error || ""}</span> },
            ]} rows={r.data?.rows || []} keyFn={(x) => x.job_id} testId="admin-reports-table" />
            <Pager page={page} pageSize={25} total={r.data?.total || 0} onPage={setPage} />
          </>
        )}
      </Panel>
    </div>
  );
}

const inputStyle = {
  flex: 1, minWidth: 220, padding: "8px 12px",
  borderRadius: 10, border: `1px solid ${BORDER}`,
  background: "white", color: INK, fontSize: 13,
};
function Loading() { return <div style={{ padding: 30, color: MUTE, fontSize: 13, textAlign: "center" }}>Loading…</div>; }
